import { faBroomDuotone } from './custom-icons/fa-broom-duotone.icon';
import { faBroomWideDuotone } from './custom-icons/fa-broom-wide-duotone.icon';
import { faBrushDuotone } from './custom-icons/fa-brush-duotone.icon';
import { faMegaphoneShout } from './custom-icons/fa-megaphone-shout.icon';

export const fac = {
  [faBroomDuotone.iconName]: faBroomDuotone,
  [faBroomWideDuotone.iconName]: faBroomWideDuotone,
  [faBrushDuotone.iconName]: faBrushDuotone,
  [faMegaphoneShout.iconName]: faMegaphoneShout,
};
